export default __webpack_public_path__ + "static/media/logo_header.4c565af3.svg";